import { useSelector } from 'react-redux';

import ListingPersonsBody from './ListingPersonsBody';
import { ensureCompositionBase } from './utils';

const View = (props) => {
  const { data } = props;

  const currentLang = useSelector((state) => state.intl.locale);
  const enforcedPath = ensureCompositionBase({
    lang: currentLang,
    ...props,
  });

  return <ListingPersonsBody {...props} data={data} path={enforcedPath} />;
};

export default View;
